import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from './auth.service';
import { NotificationService } from './notification.service';

@Injectable({
  providedIn: 'root'
})
export class AuthorizationCheckService implements CanActivate{

    private allowedLinks: Set<string> = new Set();
    
      // Routes only accessible to Role ID 1
  private onlyRole1Routes: Set<string> = new Set([
    '/smsauditreport',
    '/elephantauditreport',
    '/citizenauditreport'
  ]);

  
  // ✅ Always allowed if user is authenticated
  private universalRoutes: Set<string> = new Set([
    '/profile',
    '/changepassword'
  ]);

  constructor(private router: Router,private notifyService:NotificationService,private auth:AuthService ) { }
  //  setAllowedLinks(menu: any[]): void {
  //   const links: string[] = [];
  //   console.log("menu",menu);
  //   for (const item of menu) {
  //     if (item.linkName && item.isActive === "true") links.push(item.linkName);
  //     if (item.pLInk && Array.isArray(item.pLInk)) {
  //       for (const sub of item.pLInk) {
  //         if (sub.linkName && sub.isActive === "true") links.push(sub.linkName);
  //       }
  //     }
  //   }
  //   this.allowedLinks = new Set(links);
  //   console.log("allowedLinks",this.allowedLinks);
  // }

  setAllowedLinks(menu: any[]): void {
    const links: string[] = [];
    for (const item of menu) {
      if (item.linkName && item.isActive === "true") links.push(item.linkName.startsWith('/') ? item.linkName : '/' + item.linkName);
      if (item.pLInk && Array.isArray(item.pLInk)) {
        for (const sub of item.pLInk) {
          if (sub.linkName && sub.isActive === "true") links.push(sub.linkName.startsWith('/') ? sub.linkName : '/' + sub.linkName);
        }
      }
    }
    this.allowedLinks = new Set(links);
   // console.log( this.allowedLinks);
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    // 1. Block if not logged in
    if (!sessionStorage.getItem('token')) {
      const url = '/' + route.url.map(seg => seg.path).join('/');
      //console.log("url", url);
      if (url !== '/' && url !== '/login') { // adjust as needed
        this.notifyService.showError("Unauthorized", "Error");
      }
      sessionStorage.clear();
      this.router.navigate(['/']);
      return false;
    }
    // 2. Get route path
    const segments = route.url.map(seg => seg.path);
    const navigatePath = '/' + segments.join('/');
     //console.log("navigatePath",navigatePath)
    
   // ✅ 3. Allow universal routes if token exists
    if (this.universalRoutes.has(navigatePath)) {
      return true;
    }
    
    // ✅ 4. Allow only if roleId === '1' for special routes
    if (this.onlyRole1Routes.has(navigatePath)) {
      const roleId = sessionStorage.getItem('roleId');
      const userdata=sessionStorage.getItem('user');
      if (userdata != null) {
        const user = JSON.parse(userdata);
        const roleId = user.roleId;
          if (roleId === 1) {
            return true;
          } else {
            this.notifyService.showError("Unauthorized - Role restricted", "Error");
            this.router.navigate(['/not-found']);
            return false;
          }
      }
      //console.log("roleId",roleId)
    
    }

    if (navigatePath === '/elephantwebreporting') {
       // console.log("this.auth",this.auth)
      if (this.auth?.isWebRoportingAccess && !this.auth.isWebRoportingAccess()) {
      
        this.notifyService?.showError("Unauthorized", "Error");
        this.router.navigate(['/not-found']);
        return false;
      }
      return true;
    }

    // 5. Block if menu is not set
    if (!this.allowedLinks || this.allowedLinks.size === 0) {
      this.notifyService?.showError("Unauthorized.please relogin", "Error");
      sessionStorage.clear();
      this.router.navigate(['/']);
      return false;
    }

    // 6. Check permission for this route
    const allowedLinksArr = Array.isArray(this.allowedLinks)
      ? this.allowedLinks
      : Array.from(this.allowedLinks);

    const isAllowed = allowedLinksArr.some(link =>
      navigatePath === link || navigatePath.startsWith(link + '/')
    );
    //console.log("navigatePath", navigatePath)
    if (isAllowed) {
      // Special permission logic (optional)
      //console.log("in if")
      return true;
    } else {
     // console.log("in else")
      // 5. Block anything else (including attempts to open external/internal forbidden links)
      this.notifyService?.showError("Unauthorized", "Error");
      this.router.navigate(['/not-found']);
      return false;
    }


  }
}
